module.exports = __webpack_public_path__ + "static/img/far1_active.950472ad.png";